import Tabs from '~/js/components/resorts/accommodations/Tabs';
import Filters from '~/js/components/resorts/accommodations/Filters';
import CardsContainer from '~/js/components/resorts/accommodations/CardsContainer';
import Fetchling from '~/js/modules/fetchling';

const GoFetch = new Fetchling();
const { PureComponent, Fragment } = window.React;

export class Accommodations extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: 'loading',
      tab: 'viewAll',
      accommodations: [],
      filteredAccommodations: [],
      selectedFilters: {
        views: [],
        amenities: [],
        promotions: [],
        villages: [],
        adults: 1,
        children: 0
      }
    };
  }

  filtersAreSaved = () => sessionStorage.selectedFilters !== undefined;

  UNSAFE_componentWillMount = () => {
    const navigationType = window.performance.getEntriesByType("navigation")[0].type;
    
    const navigationWasReloadOrBack = navigationType === 'reload' || document.referrer.includes('rooms');
    if(!navigationWasReloadOrBack && this.filtersAreSaved()) {
      this.deleteFiltersFromSessionStorage();
    }
  }

  componentDidMount = () => {
    const { _updateStatus } = this;
    const rstCode = this.props.resortData.code;
    const requestBody = { resortCode: rstCode };

    GoFetch.post('/fetchRoomData/', null, requestBody)
      .then(response => {
        const { status = 'error', data = {} } = response;

        if (status === 'success' && data.roomData && data.roomData.length > 0) {
          this._updateRooms(response.data.roomData, () => {
            _updateStatus('success');
            this.roomsDidMount();
          });
        } else {
          _updateStatus('error');
        }

        return 0;
      });
  }

  deleteFiltersFromSessionStorage = () => {
    sessionStorage.removeItem('selectedFilters');
  }

  updateExistingFilters = () => {
    let selectedFilters = JSON.parse(sessionStorage.selectedFilters);
    this.setState({selectedFilters: selectedFilters});
  }

  roomsDidMount = () => {    
    if(this.filtersAreSaved()) {
        this.updateExistingFilters();
    }
  }

  _updateRooms = (accommodations, cb) => this.setState({ accommodations, filteredAccommodations: accommodations }, cb);

  _updateStatus = (status) => this.setState({ status });

  tabClick = (tab) => {
    this.reset(tab);
  }

  reset = (tab = this.state.tab) => {
    this.setState({
      tab,
      selectedFilters: {
        views: [],
        amenities: [],
        promotions: [],
        villages: [],
        adults: 1,
        children: 0
      }
    }, () => {
      const filters = document.querySelectorAll('.filter input');
      const selects = document.querySelectorAll('.occupants-select select');

      Array.from(filters).map((filter) => { filter.checked = false; });
      Array.from(selects).map((select) => { select.selectedIndex = 0; });
    });
  }

  isDisabledByTab = (accommodation) => {
    return {
      nest: accommodation.loveNest,
      butler: accommodation.butler,
      concierge: accommodation.concierge,
      luxury: !accommodation.butler && !accommodation.concierge,
      viewAll: true
    }[this.state.tab];
  }

  filterChange = (e, filter, section) => {
    const checked = e.target.checked;
    const name = e.target.name;
    const { selectedFilters } = this.state;
    const selectedfiltersCopy = JSON.parse(JSON.stringify(selectedFilters));

    if (checked) {

      selectedfiltersCopy[section] = [...selectedfiltersCopy[section], filter];
    } else {

      selectedfiltersCopy[section] = selectedfiltersCopy[section].filter((name) => name !== filter);
    }

    this.setState({ selectedFilters: selectedfiltersCopy }, this.saveFiltersToSessionStorage);
  }

  villageChange = (e, villageCode) => {
    const checked = e.target.checked;
    const { selectedFilters } = this.state;
    const newSelectedFilters = JSON.parse(JSON.stringify(selectedFilters));

    if (checked) {
      newSelectedFilters.villages.push(villageCode);
    } else {
      const index = newSelectedFilters.villages.findIndex(code => code === villageCode);

      newSelectedFilters.villages.splice(index, 1);
    }

    this.setState({ selectedFilters: newSelectedFilters }, this.saveFiltersToSessionStorage);
  }

  occupantsChange = (e, type) => {
    const { selectedFilters } = this.state;
    const newSelectedFilters = JSON.parse(JSON.stringify(selectedFilters));
    const people = e.target.value;

    type === 1 ? newSelectedFilters.adults = people : newSelectedFilters.children = people;
    
    this.setState({ selectedFilters: newSelectedFilters }, this.saveFiltersToSessionStorage);
  }

  saveFiltersToSessionStorage() {
    sessionStorage.setItem('selectedFilters', JSON.stringify(this.state.selectedFilters));
  }

  setFilteredAccommodations = (filteredAccommodations) => this.setState({ filteredAccommodations })

  getTabTitle = () => {
    return {
      nest: 'together nest suites',
      butler: 'butler level',
      concierge: 'concierge level',
      luxury: 'luxury level',
      viewAll: 'all levels'
    }[this.state.tab];
  }

  render() {
    const { accommodations, selectedFilters, tab, filteredAccommodations, status } = this.state;

    return (
      <Fragment>
        <div className="rooms-header">
          <h1 className="rooms-title">Rooms & Suites</h1>
          <Tabs tabClick={this.tabClick} tab={tab} rstCode={this.props.resortData.code} />
        </div>
        <div className="container rooms-content">
          <Filters
            tab={tab}
            accommodationsData={accommodations}
            filteredAccommodations={filteredAccommodations}
            selectedFilters={selectedFilters}
            filterChange={this.filterChange}
            villageChange={this.villageChange}
            occupantsChange={this.occupantsChange}
            isDisabledByTab={this.isDisabledByTab}
            reset={this.reset}
            rstCode={this.props.resortData.code}
          />
          <CardsContainer
            resortData={this.props.resortData}
            accommodations={accommodations}
            filters={selectedFilters}
            setFilteredAccommodations={this.setFilteredAccommodations}
            filteredAccommodations={filteredAccommodations}
            tab={this.state.tab}
            accomodationTitle={this.getTabTitle()}
            isDisabledByTab={this.isDisabledByTab}
            status={status}
            isFiltered={this.state.accommodations !== this.state.filteredAccommodations}
          />
        </div>
      </Fragment>
    );
  }
}

export default Accommodations;
